import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';


@Pipe({
    name: 'obtainable',
    standalone: true
})
export class ObtainablePipe implements PipeTransform {

  constructor(private readonly translate: TranslateService) {
  }

  transform(byRdt: boolean | null | undefined, byDownload: boolean | null | undefined): string[] {
    const obtainableCollection: string[] = [];
    if (byRdt === true) {
      obtainableCollection.push(this.translate.instant('obtainable-pipe.deliveredByRdt'));
    }
    if (byDownload === true) {
      obtainableCollection.push(this.translate.instant('obtainable-pipe.deliveredByDownload'));
    }
    if (obtainableCollection.length > 0) {
      return obtainableCollection;
    }
    return ['-'];
  }

}
